import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from '../../../language/i18n';

import Header from '../../main/components/Header';
import MobileBottomBar from '../../main/components/MobileBottomBar';

import '../style/main.css';

function NotFoundContent() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className='page_404'>
            <div className='page_404_inner'>
                {/* Decorative blobs */}
                <div className='blob blob_top' />
                <div className='blob blob_bottom' />

                {/* Illustration */}
                <div className='illustration_404'>
                    <svg viewBox='0 0 320 220' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                        {/* Ground */}
                        <ellipse cx='160' cy='195' rx='130' ry='18' fill='#E8F5E9' />

                        {/* Left plant stem */}
                        <path d='M90 195 Q88 160 95 130' stroke='#147F26' strokeWidth='3' strokeLinecap='round' />
                        <path d='M95 130 Q85 115 70 120' stroke='#147F26' strokeWidth='2.5' strokeLinecap='round' />
                        <path d='M92 150 Q80 140 68 148' stroke='#7AB30E' strokeWidth='2.5' strokeLinecap='round' />
                        <ellipse cx='68' cy='148' rx='10' ry='6' fill='#7AB30E' transform='rotate(-20 68 148)' />
                        <ellipse cx='70' cy='120' rx='12' ry='7' fill='#147F26' transform='rotate(-30 70 120)' />
                        {/* Left wheat head */}
                        <ellipse cx='95' cy='122' rx='6' ry='14' fill='#F5C842' transform='rotate(10 95 122)' />
                        <ellipse cx='100' cy='118' rx='5' ry='12' fill='#F0B830' transform='rotate(20 100 118)' />

                        {/* Right plant stem */}
                        <path d='M230 195 Q232 158 225 128' stroke='#147F26' strokeWidth='3' strokeLinecap='round' />
                        <path d='M225 128 Q235 112 252 118' stroke='#147F26' strokeWidth='2.5' strokeLinecap='round' />
                        <path d='M228 152 Q240 142 254 150' stroke='#7AB30E' strokeWidth='2.5' strokeLinecap='round' />
                        <ellipse cx='254' cy='150' rx='10' ry='6' fill='#7AB30E' transform='rotate(20 254 150)' />
                        <ellipse cx='252' cy='118' rx='12' ry='7' fill='#147F26' transform='rotate(30 252 118)' />
                        {/* Right wheat head */}
                        <ellipse cx='225' cy='120' rx='6' ry='14' fill='#F5C842' transform='rotate(-10 225 120)' />
                        <ellipse cx='220' cy='116' rx='5' ry='12' fill='#F0B830' transform='rotate(-20 220 116)' />

                        {/* 404 text in illustration */}
                        <text x='160' y='105' textAnchor='middle' fontSize='72' fontWeight='800'
                            fontFamily='Open Sans, sans-serif' fill='#E8F5E9' letterSpacing='-2'>
                            404
                        </text>
                        <text x='160' y='100' textAnchor='middle' fontSize='72' fontWeight='800'
                            fontFamily='Open Sans, sans-serif'
                            fill='url(#grad404)' letterSpacing='-2'>
                            404
                        </text>

                        {/* Small dots decoration */}
                        <circle cx='130' cy='50' r='4' fill='#7AB30E' opacity='0.4' />
                        <circle cx='195' cy='38' r='3' fill='#147F26' opacity='0.3' />
                        <circle cx='155' cy='30' r='2' fill='#F5C842' opacity='0.5' />
                        <circle cx='175' cy='58' r='2.5' fill='#7AB30E' opacity='0.35' />

                        <defs>
                            <linearGradient id='grad404' x1='100' y1='30' x2='220' y2='110' gradientUnits='userSpaceOnUse'>
                                <stop offset='0%' stopColor='#147F26' />
                                <stop offset='100%' stopColor='#7AB30E' />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>

                {/* Text block */}
                <div className='text_block_404'>
                    <h1 className='title_404'>{t('title_404')}</h1>
                    <p className='subtitle_404'>{t('message_404')}</p>
                </div>

                {/* CTA button */}
                <button className='btn_home_404' onClick={() => navigate('/')}>
                    <svg width='18' height='18' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M3 12L12 3L21 12V21H15V15H9V21H3V12Z' fill='currentColor' />
                    </svg>
                    {t('back_home_404')}
                </button>
            </div>
        </div>
    );
}

function Main() {
    const [bottomBarHidden, setBottomBarHidden] = useState(false);

    const handleBottomBarToggle = (isHidden) => {
        setBottomBarHidden(isHidden);
    };

    return (
        <I18nextProvider i18n={i18n}>
            <Header onToggleMenu={handleBottomBarToggle} />
            <NotFoundContent />
            {!bottomBarHidden && <MobileBottomBar activeTabName={'home'} />}
        </I18nextProvider>
    );
}

export default Main;
